import React from 'react';
import { Wrapper, Img } from './styled';

type Props = {
	url: string;
	alt: string;
};

const UrlIcon = ({ url, alt }: Props) => (
	<Wrapper>
		<Img src={url} alt={alt} />
	</Wrapper>
);

UrlIcon.defaultProps = {
	alt: '',
};

export default UrlIcon;
